import { ACCOUNTING, HR, MANAGER } from './roles';

export default [
  {
    title: 'managerApproval',
    path: '/requests',
    icon: 'fa fa-clock-o',
    active: true,
    roles: [MANAGER],
  },
  {
    title: 'accountantApproval',
    path: '/accounting/requests',
    icon: 'fa fa-clock-o',
    active: true,
    roles: [ACCOUNTING],
  },
  {
    title: 'payrollTransfer',
    path: '/hr/requests',
    icon: 'fa fa-exchange',
    active: false,
    roles: [HR],
  },
  {
    title: 'reports',
    path: '/reports',
    icon: 'fa fa-pie-chart',
    active: false,
    roles: [MANAGER, HR, ACCOUNTING],
  },
  {
    title: 'help',
    path: '/help',
    icon: 'fa fa-question-circle',
    active: false,
    roles: [MANAGER, HR, ACCOUNTING],
  },
];



// WEBPACK FOOTER //
// ./src/constants/admin-pages.js